import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import "./i18n"
import App from "./components/layouts/App"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { store } from "./redux/store"
import moment from "moment"
import i18n from "./i18n"
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
moment.locale(i18n.language)
i18n.language === "vi"
    ? moment.updateLocale("vi", {
          months: [
              "thg 1",
              "thg 2",
              "thg 3",
              "thg 4",
              "thg 5",
              "thg 6",
              "thg 7",
              "thg 8",
              "thg 9",
              "thg 10",
              "thg 11",
              "thg 12",
          ],
          weekdays: [
              "Chủ nhật",
              "Thứ hai",
              "Thứ ba",
              "Thứ tư",
              "Thứ năm",
              "Thứ sáu",
              "Thứ bảy",
          ],
      })
    : moment.updateLocale("en", {
          months: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
          ],
      })
